import { getAnswerFor } from '../../../selectors/markup';
import { replyTo } from '../../../actions/markup';
import connect from '../../connect';
import Question from './question.ui.jsx';

const mapStateToProps = (state, props) => ({
    rootState: state,
    answer: getAnswerFor(state, props.markup),
});

export default connect(
    mapStateToProps,
    {
        replyTo,
    },
    null,
    { pure: true }
)(Question);



// WEBPACK FOOTER //
// ./src/components/text_viewer/highlight/question.jsx